module.exports = __webpack_public_path__ + "media/img/home/clients-map/neurala-5ce1eed67ada4cbf92922cf3ee6af04f.svg";